import { IEprocBasketCompatible, IProductPrice, IProductUnit } from '@lib/product';
import { IOciArticle } from './IOciSearchResponse';

export class OciBasketProductDto implements IEprocBasketCompatible {
    productId: string;
    productNumberSupplier: string;
    productNumberManufacturer: string;
    manufacturerName: string;
    productUnit: IProductUnit;
    deliveryTimeInDays: number;
    ociProductPrices: IProductPrice[];
    productDescription: string;

    constructor(product: IOciArticle, articleNumber: string, supplierCompanyId: string) {
        this.productId = articleNumber;
        this.productNumberSupplier = supplierCompanyId;
        this.productNumberManufacturer = product.manufactMat;
        this.manufacturerName = product.manufactCode;
        this.productUnit = product.unit;
        this.deliveryTimeInDays = 0;
        this.ociProductPrices = [product.price];
        this.productDescription = product.description.name;
    }

    get id(): string {
        return this.productId;
    }

    compatibleToBasket(): boolean {
        return !!(this.productUnit.orderUnit && this.productUnit.contentUnit);
    }
}
